import React from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Navbar from './components/Navbar';
import AppRoutes from './routes/AppRoutes';
import ScrollToTop from './components/ScrollToTop';
import { CartProvider } from './context/CartContext';
import { ThemeProvider } from './context/ThemeContext';
import { ProfileProvider } from './context/ProfileContext';
import { AuthProvider } from './context/AuthContext';
import { DiningProvider } from './context/DiningContext';
import './App.css';

function AppContent() {
  const location = useLocation();
  const isNotificationPage = location.pathname === '/notification';
  const isOrdersPage = location.pathname === '/orders';
  const isSupportChatPage = location.pathname === '/support/chat';
  const hideTopNavOnMobile = isNotificationPage || isOrdersPage || isSupportChatPage;

  return (
    <div className="App bg-white dark:bg-gray-900 min-h-screen transition-colors duration-300">
      <ScrollToTop />
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#333',
            color: '#fff',
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#10b981',
              secondary: '#fff',
            },
          },
          error: {
            duration: 4000,
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />
      <Navbar />
      <main key={location.pathname} className={`main-content pb-20 md:pb-0 ${hideTopNavOnMobile ? 'md:mt-[72px] mt-0' : ''}`}>
        <AppRoutes />
      </main>
    </div>
  );
}

function App() {
  return (
    <Router>
      <ThemeProvider>
        <DiningProvider>
          <ProfileProvider>
            <AuthProvider>
              <CartProvider>
                <AppContent />
              </CartProvider>
            </AuthProvider>
          </ProfileProvider>
        </DiningProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
